///jacques-andre-editeur\proshop-v2\frontend\src\screens\SearchScreen.jsx
import { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { useGetBooksQuery } from '../slices/booksApiSlice';
import { useGetAuthorsQuery } from '../slices/authorsApiSlice';
import { useGetBooksCollectionsQuery } from '../slices/booksCollectionsApiSlice';
import BookCard from '../components/BookCard';
import AuthorCard from '../components/AuthorCard';
import BooksCollectionCard from '../components/BooksCollectionCard';
import Loader from '../components/Loader';
import Message from '../components/Message';
import Paginate from '../components/Paginate';
import Meta from '../components/Meta';

const SearchScreen = () => {

  const params = useParams();

  // Utilisation de useState pour gérer les valeurs des paramètres
  const [pageNumber, setPageNumber] = useState(params.pageNumber || 1);
  const [keyword, setKeyword] = useState(params.keyword || '');

  // Effect pour mettre à jour si params change
  useEffect(() => {
    setPageNumber(params.pageNumber || 1);
    setKeyword(params.keyword || '');
  }, [params]);

  const parPage = 12;

  const { data: livres, isLoading, error } = useGetBooksQuery({
    keyword,
    pageNumber,
    parPage
  });

  const { data: auteurs, authorsIsLoading, authorsError } = useGetAuthorsQuery({
    keyword,
    pageNumber,
    parPage
  });

  const { data: collections, booksCollectionsIsLoading, booksCollectionsError } = useGetBooksCollectionsQuery({
    keyword,
    pageNumber,
    parPage
  });



  return (
    <div>
      <Meta />
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant='danger'>
          {error?.livres?.message || error.error}
        </Message>
      ) : (
        <Container>
          <div className="h1-container">
          {(livres?.books?.length === 0 && auteurs?.authors?.length === 0 && collections?.booksCollections?.length === 0) ? (
            <h1>Aucun résultat pour : {keyword}</h1>
          ) : (
            <h1>Résultats de la recherche pour : {keyword}</h1>
          )}
          </div>

          {livres?.books?.length > 0 && (
            <>
              <div className="h2-container">
                <h2>Livres</h2>
              </div>
              <div className="book-row">
                {livres.books.map((book) => (
                  <div className='book-card' key={book._id}>
                    <BookCard book={book} />
                  </div>
                ))}
              </div>

              <Paginate 
                pages={livres.pages}
                page={livres.page}
                keyword={keyword ? keyword : ''}
              />
            </>
          )}

          {auteurs?.authors?.length > 0 && (
            <>
              <div className="h2-container">
                <h2>Auteurs</h2>
              </div>
              <div className="author-row">
                {auteurs.authors.map((author) => (
                  <div className='author-card' key={author._id}>
                    <AuthorCard author={author} />
                  </div>
                ))}
              </div>

              <Paginate 
                pages={auteurs.pages}
                page={auteurs.page}
                keyword={keyword ? keyword : ''}
              />
            </>
          )}

          {collections?.booksCollections?.length > 0 && (
            <>
              <div className="h2-container">
                <h2>Collections</h2>
              </div>
              <div className="booksCollectionRow">
                {collections.booksCollections.map((booksCollection) => (
                  <div className='booksCollection-card' key={booksCollection._id}>
                    <BooksCollectionCard booksCollection={booksCollection} />
                  </div>
                ))}
              </div>

              <Paginate 
                pages={collections.pages}
                page={collections.page}
                keyword={keyword ? keyword : ''}
              />
            </>
          )}

        </Container>
      )}
    </div>
  );
};

export default SearchScreen;
